import { Component, OnInit } from '@angular/core';
import { SeoService } from '../services/seo.service';

@Component({
  selector: 'app-terms',
  standalone: true,
  imports: [],
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.scss']
})
export class TermsComponent implements OnInit {
  constructor(private seo: SeoService) {}

  ngOnInit(): void {
    this.seo.updateTags({
      title: 'Obchodní podmínky',
      description: 'Obchodní podmínky používání služeb Logical Finance. Informace o poskytovaných službách, cenách a právních podmínkách.',
      keywords: 'obchodní podmínky, podmínky použití, legal',
      url: '/obchodni-podminky'
    });
  }
}

